export default "/images/vendor/flag-icon-css/flags/1x1/eu.svg?227190d1fe778a97104cf8438db85764";